import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import api from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    orderDetails: {},
    rmaDetails: {},
    returns: [],
    returnMethod: null,
    collectionAddress: {},
  },
  mutations: {
    SET_ORDER_DETAILS(state, orderDetails) {
      state.orderDetails = orderDetails
    },
    SET_RMA_DETAILS(state, rmaDetails) {
      state.rmaDetails = rmaDetails
    },
    SET_RETURNS(state, returns) {
      state.returns = returns
    },
    SET_RETURN_METHOD(state, returnMethod) {
      state.returnMethod = returnMethod
    },
    SET_COLLECTION_ADDRESS(state, collectionAddress) {
      state.collectionAddress = collectionAddress
    },
  },
  actions: {
    reset({ commit }) {
      commit('SET_RMA_DETAILS', {})
      commit('SET_ORDER_DETAILS', {})
      commit('SET_RETURN_METHOD', null)
      commit('SET_RETURNS', [])
      commit('SET_COLLECTION_ADDRESS', {})
    },
    getOrderDetails({ commit }, payload) {
      return new Promise((resolve, reject) => {
        return api
          .post('/order-details', {
            orderId: payload.orderId,
            postcode: payload.postcode,
          })
          .then(res => {
            if (res.data && res.data.orderId) {
              commit('SET_ORDER_DETAILS', res.data)
              return resolve()
            }

            if (res.data && res.data.message) {
              return reject(res.data.message)
            }

            return reject(
              'There was a problem processing your request. Please try again in a few minutes or contact us for assistance. (error code 1)'
            )
          })
          .catch(err => {
            let message =
              'There was a problem processing your request. Please try again in a few minutes or contact us for assistance. (error code 2)'
            try {
              message = err.response.data.message
            } catch (e) {
              //ignored
            }
            return reject(message)
          })
      })
    },
    submitRma({ commit }, payload) {
      return new Promise((resolve, reject) => {
        return api
          .post('/rma', payload)
          .then(res => {
            if (res.data && res.data.number) {
              commit('SET_RMA_DETAILS', res.data)
              return resolve(res)
            }

            return reject(
              'There was a problem processing your request. Please try again in a few minutes or contact us for assistance. (error code 3)'
            )
          })
          .catch(err => {
            let message =
              'There was a problem processing your request. Please try again in a few minutes or contact us for assistance. (error code 4)'
            try {
              message = err.response.data.message
            } catch (e) {
              //ignored
            }
            return reject(message)
          })
      })
    },
    setProductsToReturn({ commit }, payload) {
      return new Promise(resolve => {
        let returns = []
        payload
          .filter(i => i.selected === true)
          .map(product => {
            for (let quantity = 1; quantity <= product.quantity; quantity++) {
              returns.push({
                ...product,
                quantity,
              })
            }
          })

        commit('SET_RETURNS', returns)

        resolve()
      })
    },
    setReturns({ commit }, payload) {
      return new Promise(resolve => {
        commit('SET_RETURNS', payload)

        resolve()
      })
    },
    setReturnMethod({ commit }, returnMethod) {
      return new Promise(resolve => {
        commit('SET_RETURN_METHOD', returnMethod)

        resolve()
      })
    },
    setCollectionAddress({ commit }, collectionAddress) {
      return new Promise(resolve => {
        commit('SET_COLLECTION_ADDRESS', collectionAddress)

        resolve()
      })
    },
  },
  getters: {
    orderDetails: state => state.orderDetails,
    returns: state => state.returns,
    returnMethod: state => state.returnMethod,
    collectionAddress: state => state.collectionAddress,
    largeParcelCount: state => state.returns.filter(i => i.largeParcel === true).length,
  },
  plugins: [createPersistedState({ key: 'customerreturns.co.uk' })],
})
